import type { AttributionSpan } from '@/pages/app/AttributionViewer/artifactDerivations'

type Interval = { start: number; end: number }

export function liveOverlaps(spans: AttributionSpan[]): Interval[] {
  const events: { time: number; source: 'mic' | 'system'; delta: number }[] = []
  for (const span of spans) {
    const source = span.speaker?.captureSource
    if (source !== 'mic' && source !== 'system') continue
    if (span.end_ms <= span.start_ms) continue
    events.push({ time: span.start_ms, source, delta: 1 }, { time: span.end_ms, source, delta: -1 })
  }
  events.sort((a, b) => a.time - b.time)
  const active = { mic: 0, system: 0 }
  const overlaps: Interval[] = []
  let previous = 0
  for (const event of events) {
    if (active.mic > 0 && active.system > 0 && event.time > previous) {
      const last = overlaps[overlaps.length - 1]
      if (last?.end === previous) last.end = event.time
      else overlaps.push({ start: previous, end: event.time })
    }
    active[event.source] += event.delta
    previous = event.time
  }
  return overlaps
}
